module.exports = __webpack_public_path__ + "img/speciment02.08ecc740.png";